import type { ReduxState } from '@/redux/app/state';

export const bulkCreateActionStatusSelector = (state: ReduxState) =>
  state.bulk.createActionStatus;

export const bulkActionQueueSelector = (state: ReduxState) =>
  state.bulk.queue;
